import type { HTMLAttributes } from 'react'
import { Toaster } from 'react-hot-toast'
import GlobalStyles from './GlobalStyles'
import ServiceWorkerManager from './ServiceWorkerManager'
import WhatsNewModal from './WhatsNewModal'
import WhatsNewTip from './WhatsNewTip'

export interface GlobalComponentsProps extends HTMLAttributes<HTMLDivElement> {}

export default function GlobalComponents({ ...props }: GlobalComponentsProps) {
	return (
		<>
			<GlobalStyles />

			<WhatsNewTip />
			<WhatsNewModal />
			<Toaster />

			<ServiceWorkerManager />
		</>
	)
}
